export * from './src/cloud-resourceusage-v1-resource-usage-data.meta.js';
